/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { PageLayout } from '../common/PageLayout';
import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';
import { pageStateSelectors } from '../../../app/page/page-state/page-state.selectors';
import { initialCompanyContextPage } from '../../../app/page/company-context/company-context.actions';
import { authSelectors } from '../../../app/auth/auth.selectors';
import { companyContextsSelectors } from '../../../app/resource/company-contexts/company-contexts.selectors';
import { companyToolsCategorySelectors } from '../../../app/resource/company-tools-category/company-tools-category.selectors';
import { ICompanyContext } from '../../../app/resource/company-contexts/company-contexts.types';
import { Breadcrumb } from '../common/Breadcrumb';
import { Section } from './Section';
import { SectionReadOnly } from './SectionReadOnly';

export const CompanyVisionPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { companyContextId } = useParams<{ companyContextId: ICompanyContext['id'] }>();
  const isEditRoute = useRouteMatch('/agency-tools/context/:companyContextId/edit');

  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'companyContext');
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);
  const companyContext = useSelectWithParams(companyContextsSelectors.selectResourceById, companyContextId);
  const companyToolsCategory = useSelectWithParams(
    companyToolsCategorySelectors.selectResourceById,
    companyContext?.companyToolsCategoryId ?? '',
  );

  const isEditing = isAdmin && Boolean(isEditRoute);

  useEffect(() => {
    dispatch(initialCompanyContextPage());
  }, [dispatch]);

  useEffect(() => {
    if (!isAdmin && isEditRoute) {
      history.replace(`/agency-tools/context/${companyContextId}`);
    }
  }, [companyContextId, history, isAdmin, isEditRoute]);

  useEffect(() => {
    if (!showLoader && !companyContext) {
      history.replace('/agency-tools');
    }
  }, [companyContext, history, showLoader]);

  return (
    <PageLayout showLoader={showLoader}>
      <div className="row mb-25">
        <div className="col-12">
          <div className="panel">
            <div className="no-border panel-header small-header breadcrumb-header">
              <div className="breadcrumb-header__content">
                <Breadcrumb
                  items={[
                    { name: 'Agency Tools', path: '/agency-tools' },
                    { name: companyToolsCategory?.title ?? '', path: '/agency-tools' },
                    { name: companyContext?.title ?? '' },
                  ]}
                />
                <div className="breadcrumb-header__title-row">
                  <h2 className="bold">Agency Tools</h2>
                  {isAdmin && companyContext && (
                    <div className="flex aic jcr">
                      {isEditing ? (
                        <a
                          className="btn btn-md themed-bg"
                          title="Back to read-only view"
                          onClick={() => history.push(`/agency-tools/context/${companyContextId}`)}
                        >
                          View
                        </a>
                      ) : (
                        <a
                          className="btn btn-md themed-bg"
                          title="Edit"
                          onClick={() => history.push(`/agency-tools/context/${companyContextId}/edit`)}
                        >
                          Edit
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {companyContext ? (
              <div className="agency-tools panel-body pt-0">
                <div className="border-radius-1 lightGray-bg p-2">
                  <div className="row big-gap">
                    <div className="col-12">
                      {isEditing ? (
                        <Section companyContextId={companyContextId} />
                      ) : (
                        <SectionReadOnly companyContextId={companyContextId} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              !showLoader && (
                <div className="agency-tools panel-body pt-0">
                  <div className="border-radius-1 lightGray-bg p-2">
                    <p style={{ textAlign: 'center' }}>Context not found</p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
